import React, { useContext } from "react";
import { withHoverDrawer } from "../../HOCs";
import { AuthorizationAiqoe } from "atp-authorization-aiqoe";
import { EnvContext } from "../../contexts";

const Repository = () => {

  const { envConfig } = useContext(EnvContext);
  return (
    <div>
      <AuthorizationAiqoe runtimeEnv={envConfig}/>
    </div>
  );
};

export default withHoverDrawer(Repository);
